import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CDN_HOST } from 'env/env.dev';
import type { ReactNode } from 'react';

import './EventsHero.scss';

interface EventsHeroProps {
  className?: string;
  title?: string;
  textOne?: string;
  textTwo?: string;
  image?: string;
  readMoreLink?: string;
  readMoreInternal?: boolean;
  readMoreText?: string;
  registerLink?: string;
  registerText?: string;
  extraActions?: ReactNode;
}

const EventsHero = ({
  className,
  title,
  textOne,
  textTwo,
  image,
  readMoreLink,
  readMoreInternal,
  readMoreText,
  registerLink,
  registerText,
  extraActions,
}: EventsHeroProps) => {
  const { t } = useTranslation(["events"]);
  const showActions = registerLink || readMoreInternal || readMoreText || extraActions;

  return (
    <section className={`EventsHero${className ? ` ${className}` : ""}`}>
      <div className="wrapper">
        <h2>{title || t("eventsTitle")}</h2>
        <div className="EventsHero__content">
          <p>{textOne || t("eventsTextOne")}</p>
          <p>{textTwo || t("eventsTextTwo")}</p>
          {showActions ? (
            <div className="EventsHero__actions">
              {registerLink && (
                <a href={registerLink} className="EventsHero__button EventsHero__button--primary" target="_blank" rel="noopener noreferrer">
                  {registerText || t("eventButton")}
                </a>
              )}
              {readMoreLink && readMoreInternal ? (
                <Link to={readMoreLink} className="EventsHero__read-more EventsHero__button EventsHero__button--secondary">
                  {readMoreText || t("readMoreLink")}
                </Link>
              ) : readMoreLink && (
                <a href={readMoreLink} className="EventsHero__read-more" target="_blank" rel="noopener noreferrer">
                  {readMoreText || t("readMoreLink")}
                </a>
              )}
              {extraActions}
            </div>
          ) : readMoreLink && (
            <a href={readMoreLink} className="EventsHero__read-more" target="_blank" rel="noopener noreferrer">
              {t("readMoreLink")}
            </a>
          )}
        </div>

        <figure className="EventsHero__image">
          <img src={image || `${CDN_HOST}/images/events-section.png`} alt="Our Events" width="540" height="422" loading="lazy" />
        </figure>
      </div>
    </section>
  );
};

export default EventsHero;
